import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '@shared/shared.service';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { enMessage } from '@shared/en-us-message';

@Component({
    selector: 'app-notify-message',
    templateUrl: './notify-message.component.html',
    styleUrls: ['./notify-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class NotifyMessageComponent implements OnInit {
  responseMessage: any = {};
  translateMessage: string;
  private readonly destroyRef = inject(DestroyRef);
  private clearToastTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(public router: Router, public translate: TranslateService, public sharedService: SharedService) {
    this.destroyRef.onDestroy(() => this.clearScheduledToastClear());

    this.sharedService.changeEmittedNotify$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      this.clearScheduledToastClear();
      this.showMessage(data);
    });

    this.router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event) => {
      // Keep toast when only query params change (e.g. clearing /login?msg=1).
      const currentPath = this.router.url.split('?')[0];
      const nextPath = event.url.split('?')[0];
      if (currentPath !== nextPath) {
        this.clearToast();
      }
    });
  }

  ngOnInit() {
    const pending = this.sharedService.takeResponseMessageAfterNavigation();
    if (pending) {
      this.showMessage(pending);
    }
  }

  private showMessage(data) {
    if (this.sharedService.hasToastHost) {
      return;
    }
    if (data.type == 'popup') {
      this.responseMessage = data;
      const errorArgs = {};
      if (this.responseMessage.error.args) {
        this.responseMessage.error.args.forEach((item, i) => {
          errorArgs[i] = item;
        });
      }
      // if(errorArgs) {
      this.translate.get(this.responseMessage.error.errorCode, errorArgs).subscribe((res: string) => {
        this.translateMessage = res;
      });
      // } else {
      //   this.translate.get(this.responseMessage.message).subscribe((res: string) => {
      //     this.translateMessage = res;
      //   });
      // }
    } else if (data.success == 0 && data.message) {
      this.responseMessage = data;
      const errorArgs = {};
      if (this.responseMessage && this.responseMessage.error && this.responseMessage.error.args) {
        this.responseMessage.error.args.forEach((item, i) => {
          errorArgs[i] = item;
        });
      }
      if (errorArgs && Object.keys(errorArgs).length !== 0) {
        this.translate.get(this.responseMessage.error.errorCode, errorArgs).subscribe((res: string) => {
          this.translateMessage = res;
        });
      } else {
        this.setTranslateMessage(this.responseMessage.message);
      }
      this.scheduleToastClear(data.timeOut ? data.timeOut : enMessage.timeOut);
    } else if (data.success == 0 && data.custommessage) {
      this.responseMessage = data;
      this.setTranslateMessage(this.responseMessage.custommessage);
      this.scheduleToastClear(data.timeOut ? data.timeOut : enMessage.timeOut);
    } else if (data.success == 1 && data.message) {
      this.responseMessage = data;
      this.setTranslateMessage(this.responseMessage.message);
      this.scheduleToastClear(data.timeOut ? data.timeOut : enMessage.timeOut);
    }
    else if (data.success == 'noInternet') {
      this.responseMessage = data;
      this.translate.get(this.responseMessage.message).subscribe((res: string) => {
        this.translateMessage = res;
      });
    } else if (data.success == 'internetIsBack') {
      this.responseMessage = data;
      this.translate.get(this.responseMessage.message).subscribe((res: string) => {
        this.translateMessage = res;
      });
      this.scheduleToastClear(1);
    } else if (!data || (data.success == null && !data.message && !data.custommessage && !data.type)) {
      this.clearToast();
    }
  }

  reloadPage() {
    window.location.reload();
  }

  private setTranslateMessage(message: string) {
    if (typeof message === 'string' && message.includes(' ') && message.includes('.')) {
      this.translateMessage = message;
      return;
    }
    this.translate.get(message).subscribe((res: string) => {
      this.translateMessage = typeof res === 'string' && res ? res : message;
    });
  }

  private scheduleToastClear(timeOut: number) {
    this.clearToastTimeout = setTimeout(() => {
      this.clearToast();
    }, timeOut);
  }

  private clearScheduledToastClear() {
    if (this.clearToastTimeout != null) {
      clearTimeout(this.clearToastTimeout);
      this.clearToastTimeout = null;
    }
  }

  private clearToast() {
    this.clearScheduledToastClear();
    this.responseMessage = {};
    this.translateMessage = '';
  }

}
